<template>
  <Schema v-if="getSchema" :text="getSchema" />
</template>

<script>
import { mapGetters } from 'vuex';
import Schema from './json-schema.vue';

export default {
    name: 'VirtualTourSchema',
    components: { Schema },
    computed: {
        ...mapGetters('dpp', ['dpp']),
        getSchema() {
          let validStr = null;
          let startDateStr = null;
          let endDateStr = null;

          if (this.dpp.isActive && this.dpp.virtualLink) {
            const now = new Date();
            validStr = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}T${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
            now.setDate(now.getDate()+1);
            startDateStr = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`;
            now.setDate(now.getDate()+7);
            endDateStr = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`;
          }

          const schema = {
            "@context": "http://schema.org",
            "@type": "Event",
            "name": "Virtual Tour Available",
            "url": this.dpp.dppUrl || '',
            "startDate": startDateStr || '',
            "endDate": endDateStr || '',
            "location": [
                {
                    "@type": "VirtualLocation",
                    "url": this.dpp.dppUrl || '',
                },
                {
                    "@type": "Place",
                    "name": this.dpp.geo.formatAddress || '',
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": this.dpp.geo.lat || '',
                        "longitude": this.dpp.geo.lng || '',
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": this.dpp.geo.address || '',
                        "addressLocality": this.dpp.geo.city || '',
                        "postalCode": this.dpp.geo.zipcode || '',
                        "addressRegion": this.dpp.geo.state || '',
                    }
                }
            ],
            "description": "Virtual Tour Available",
            "image": this.dpp.tnImgPath || '',
            "offers": {
                "@type": "Offer",
                "url": this.dpp.dppUrl || '',
                "validFrom": validStr || '',
                "availability": "http://schema.org/InStock",
                "price": this.dpp.price || '',
                "priceCurrency": "USD",
            },
            "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventMovedOnline",
          }

          return startDateStr ? JSON.stringify(schema) : false;
        },
    },
};
</script>
